'use client';

import { SessionProvider } from "next-auth/react";
import { ToastProvider } from "./ToastProvider";
import { useEffect, useState } from "react";

export function Providers({ children }: { children: React.ReactNode }) {
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    setIsOnline(typeof navigator !== 'undefined' ? navigator.onLine : true);
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <SessionProvider 
      refetchOnWindowFocus={isOnline} 
      refetchInterval={isOnline ? 120 : 0}
      refetchWhenOffline={false}
    >
      <ToastProvider>
        {children}
      </ToastProvider>
    </SessionProvider>
  );
}
